<template>
  <v-navigation-drawer
      :mini-variant-width="70"
      app
      :permanent="!isMobile"
      :expand-on-hover="!isMobile"
      v-model="isMenuOpen"
      :style="{ background: 'var(--main-color)', height: '100%' }"
  >
    <v-list>
      <div v-for="(menu, i) in processedMenus" :key="'menu-professor-' + i">
        <list-item
            v-if="!menu.group"
            :item="menu"
            @modalAppAgenda="$emit('modalAppAgenda')"
            @modalSair="$emit('modalSair')"
            @action="clickAcaoMenu"
        />
        <list-group-item
            v-else
            @modalAppAgenda="$emit('modalAppAgenda')"
            @action="clickAcaoMenu"
            :menu="menu"
        />
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ListItem from "./ListItem";
import ListGroupItem from "./ListGroupItem";
import api from "@/api";
import educarMaxiaService from "@/utils/services/educarMaxiaService";

export default {
  name: "NavbarGestor",
  props: ["toggleMenu", "modalAppAgenda"],
  components: { ListItem, ListGroupItem },

  data() {
    return {
      isMenuOpen: false,
      menus: [],
      grupoEducarInfo: {
        is_grupo_educar: false,
        municipio: null
      },
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600;
    },
    
    shouldShowMaxiaOption() {
      return educarMaxiaService.shouldShowMaxiaOption(this.grupoEducarInfo);
    },

    processedMenus() {
      
      if (!this.shouldShowMaxiaOption) {
        return this.menus;
      }

      return this.menus.map(menu => {
        if (menu.group && menu.itens) {
          const processedItens = menu.itens.map(item => {
            if (item.slug === "avaliacoes") {
              return {
                ...item,
                action: () => this.handleAvaliacaoClick(item)
              };
            }
            return item;
          });

          return {
            ...menu,
            itens: processedItens
          };
        }

        if (menu.slug === "avaliacoes") {
          return {
            ...menu,
            action: () => this.handleAvaliacaoClick(menu)
          };
        }

        return menu;
      });
    },
  },

  watch: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  async created() {
    await this.fetchMenus();
    await this.checkGrupoEducar();
  },

  methods: {
    async fetchMenus() {
      try {
        const response = await api.get("/modulos/lista");
        if (!response.data) {
          throw new Error("Resposta da API está vazia!");
        }
        this.menus = response.data;
        console.log('Menus carregados:', this.menus);
      } catch (error) {
        console.error("Erro ao buscar o menu:", error.response ? error.response.data : error.message);
      }
    },

    async checkGrupoEducar() {
      try {
        this.grupoEducarInfo = await educarMaxiaService.checkGrupoEducar();
      } catch (error) {
        console.error("Erro ao verificar o grupo Educar:", error.message);
      }
    },

    handleAvaliacaoClick(item) {
      this.$emit('showAvaliacaoModal', item);
    },

    clickAcaoMenu(menu) {

      if (this.isAvaliacaoItem(menu) && this.shouldShowMaxiaOption) {
        this.handleAvaliacaoClick(menu);
      } else if (menu.action) {
        console.log('Executando action do menu');
        menu.action();
      } else if (menu.rota) {
        this.$router.push(menu.rota);
      }
    },

    isAvaliacaoItem(item) {
      return item.slug === "avaliacoes" ||
          item.rota?.includes("avaliacoes") ||
          item.titulo?.toLowerCase().includes("avaliação") ||
          item.titulo?.toLowerCase().includes("avaliacao");
    },
  },
};
</script>
